
// import React, { useEffect, useState } from "react";

// import PropTypes from "prop-types"; 

// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import CircularProgress from "@mui/material/CircularProgress"; // Import the loader

// // Examplad Media Pricing Portal components
// import MDBox from "components/MDBox";

// // Examplad Media Pricing Portal example components
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DataTable from "examples/Tables/DataTable";

// // Material UI Icons
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";

// // Material UI components for modal
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogContent from "@mui/material/DialogContent";
// import DialogTitle from "@mui/material/DialogTitle";
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
// import { Snackbar } from "@mui/material";

// function CarrieirPage() {
//   const [columns, setColumns] = useState([]);
//   const [rows, setRows] = useState([]);
//   const [open, setOpen] = useState(false); // Modal state
//   const [loading, setLoading] = useState(true); // Loader state
//   const [selectedUser, setSelectedUser] = useState(null); // User to edit
//   const [deleteBox, setDeleteBox] = useState(false); // Modal state
//   const [deleteUserId, setDeleteUserId] = useState(""); // Modal state
//   const [searchTerm, setSearchTerm] = useState(""); // Search term state

//   const [formData, setFormData] = useState({
//     email: "",
//     mobileNumber: "",
//     userRole: "",
//     margin: "",
//     password: "",
//     userId:""
//   });

//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [SnackbarMsg, setSnackbarMsg] = useState("");

//   const fetchUsers = async () => {
//     setLoading(true); // Set loading to true before fetching data

//     try {

//       const sessionToken = localStorage.getItem("sessionToken");

//       const response = await fetch("https://api.exampladmedia.com/api/subscribers/getall", {
//         method: "GET",
//         headers: {
//           "Authorization": sessionToken,
//         }
//       });

//       const data = await response.json();

//       if (data && data.data) {
//         // Define table columns
//         const userColumns = [
//          { Header: "srNo", accessor: "srNo", align: "center" },
//           { Header: "Name", accessor: "userName", align: "center" },
//           { Header: "Email", accessor: "email", align: "center" },
//           { Header: "Phone Number", accessor: "phoneNumber", align: "center" },
//           { Header: "Customer", accessor: "customer", align: "center" },
//           { Header: "Position", accessor: "position", align: "center" },

//           {
//             Header: "Delete",
//             accessor: "delete",
//             align: "center",
//             Cell: ({ row }) => (
//               <DeleteIcon
//                 style={{ color: "red", cursor: "pointer" }}
//                 onClick={() => handleConfirmDelete(row.original.userId)}
//               />
//             ),
//           },
         
//         ];

//         // Create rows by mapping through API data
//         const userRows = data.data.map((user, index) => ({
//           srNo: index + 1,
//           userName: user.userName,
//           email: user.email,
//           phoneNumber: user.phoneNumber,
//           customer: user.customer,
//           position: user.position,
//           userId: user.userId,
//           actions: (
//             <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
//               <EditIcon
//                 style={{
//                   color: "green",
//                   cursor: "pointer",
//                 }}
//                 onClick={() => handleEdit(user)}
//               />
//               <DeleteIcon
//                 style={{
//                   color: "red",
//                   cursor: "pointer",
//                 }}
//                 onClick={() => handleConfirmDelete(user.userId)}
//               />
//             </div>
//           ),
//         }));

//         setColumns(userColumns);
//         setRows(userRows);
//         console.log(userRows)
//       }
//     } catch (error) {
//       console.error("Error fetching users:", error);
//     } finally {
//       setLoading(false); // Set loading to false after data is loaded
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const handleConfirmDelete = (userId) => {
//     setDeleteUserId(userId);
//     setDeleteBox(true);
//   };

//   const handleDelete = async () => {
//     try {

//       const sessionToken = localStorage.getItem("sessionToken");
      
//       const response = await fetch(
//         `https://api.exampladmedia.com/api/subscribers/remove/${deleteUserId}`,
//         {
//           method: "DELETE",
//           headers: {
//             "Authorization": sessionToken,
//           },
//         }
//       );

//       if (response.ok) {
//         setSnackbarMsg("Subscriber deleted successfully!");
//         setOpenSnackbar(true);
//         fetchUsers(); // Refresh the user list
//       } else {
//         setSnackbarMsg("Failed to delete subscriber.");
//         setOpenSnackbar(true);
//       }
//     } catch (error) {
//       console.error("Error deleting subscriber:", error);
//       setSnackbarMsg("An error occurred while deleting the subscriber.");
//       setOpenSnackbar(true);
//     } finally {
//       setDeleteBox(false);
//     }
//   };

//   const handleDeleteCancel = () => {
//     setDeleteBox(false);
//   };

//   // Filter rows based on search term
//   const filteredRows = rows.filter(row => 
//     row.userName.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <DashboardLayout>
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox
//                 mx={2}
//                 mt={-3}
//                 py={3}
//                 px={2}
//                 variant="gradient"
//                 bgColor="info"
//                 borderRadius="lg"
//                 coloredShadow="info"
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//               >
//                 <h2 style={{ color: "white", margin: 0 }}>Subscriber List</h2>
//                 <TextField
//                   variant="outlined"
//                   placeholder="Search by name..."
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   style={{ backgroundColor: "white", borderRadius: "4px" }}
//                 />
//               </MDBox>
//               <MDBox pt={3}>
//                 {loading ? (
//                   <MDBox
//                     display="flex"
//                     justifyContent="center"
//                     alignItems="center"
//                     height="300px"
//                   >
//                     <CircularProgress color="info" />
//                   </MDBox>
//                 ) : (
//                   <DataTable
//                     table={{ columns, rows: filteredRows }}
//                     isSorted={false}
//                     entriesPerPage={false}
//                     showTotalEntries={false}
//                     noEndBorder
//                   />
//                 )}
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>

//       {/* Edit User Modal */}

//       <Dialog open={deleteBox} onClose={handleDeleteCancel}>
//         <DialogTitle>Delete Subscriber</DialogTitle>
//         <DialogContent>
//           Are you sure you want to delete this subscriber?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleDeleteCancel} color="primary">
//             Cancel
//           </Button>
//           <Button onClick={handleDelete} color="secondary">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Snackbar for Notifications */}
//       <Snackbar
//         open={openSnackbar}
//         message={SnackbarMsg}
//         autoHideDuration={2000}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         onClose={() => setOpenSnackbar(false)}
//       />
//     </DashboardLayout>
//   );
// }

// // Prop-Type Validation for the `row` object
// CarrieirPage.propTypes = {
//   row: PropTypes.shape({
//     original: PropTypes.shape({
//       userId: PropTypes.string.isRequired,
//     }).isRequired,
//   }).isRequired,
// };

// export default CarrieirPage;






import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress"; // Import the loader
import PropTypes from "prop-types"; 
// Examplad Media Pricing Portal components
import MDBox from "components/MDBox";

// Examplad Media Pricing Portal example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";

// Material UI Icons
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

// Material UI components for modal
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Snackbar } from "@mui/material";
import dayjs from 'dayjs';

function CarrieirPage() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false); // Modal state
  const [loading, setLoading] = useState(true); // Loader state
  const [selectedUser, setSelectedUser] = useState(null); // User to edit
  const [deleteBox, setDeleteBox] = useState(false); // Modal state
  const [deleteUserId, setDeleteUserId] = useState(""); // Modal state
  const [searchTerm, setSearchTerm] = useState(""); // Search term state

  const [formData, setFormData] = useState({
    email: "",
    mobileNumber: "",
    userRole: "",
    margin: "",
    password: "",
    userId: ""
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [SnackbarMsg, setSnackbarMsg] = useState("");

  const fetchUsers = async () => {
    setLoading(true); // Set loading to true before fetching data

    try {
      const sessionToken = localStorage.getItem("sessionToken");

      const response = await fetch("https://api.exampladmedia.com/api/subscribers/getall", {
        method: "GET",
        headers: {
          "Authorization": sessionToken,
        }
      });

      const data = await response.json();

      if (data && data.data) {
        // Filter data to show only customers with type "CARRIER"
        const carrierData = data.data.filter(user => user.customer === "CARRIER");

        // Define table columns
        const userColumns = [
          { Header: "srNo", accessor: "srNo", align: "center" },
          { Header: "Name", accessor: "userName", align: "center" },
          { Header: "Email", accessor: "email", align: "center" },
          { Header: "Phone Number", accessor: "phoneNumber", align: "center" },
          // { Header: "Customer", accessor: "customer", align: "center" },
          { Header: "Position", accessor: "position", align: "center" },
          { Header: "Form Filled", accessor: "filled_by", align: "center" },
          {
            Header: "Delete",
            accessor: "delete",
            align: "center",
            Cell: ({ row }) => (
              <DeleteIcon
                style={{ color: "red", cursor: "pointer" }}
                onClick={() => handleConfirmDelete(row.original.userId)}
              />
            ),
          },
        ];

        // Create rows by mapping through filtered data
        const userRows = carrierData.map((user, index) => ({
          srNo: index + 1,
          userName: user.userName,
          email: user.email,
          phoneNumber: user.phoneNumber,
          customer: user.customer,
          position: user.position,
          filled_by: user.filled_by ? dayjs(user.filled_by).format("DD-MMM-YYYY HH:mm:ss") : "-",
          userId: user.userId,
          actions: (
            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              <EditIcon
                style={{
                  color: "green",
                  cursor: "pointer",
                }}
                // onClick={() => handleEdit(user)}
              />
              <DeleteIcon
                style={{
                  color: "red",
                  cursor: "pointer",
                }}
                onClick={() => handleConfirmDelete(user.userId)}
              />
            </div>
          ),
        }));

        setColumns(userColumns);
        setRows(userRows);
        console.log(userRows);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false); // Set loading to false after data is loaded
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleConfirmDelete = (userId) => {
    setDeleteUserId(userId);
    setDeleteBox(true);
  };

  const handleDelete = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");

      const response = await fetch(
        `https://api.exampladmedia.com/api/subscribers/remove/${deleteUserId}`,
        {
          method: "DELETE",
          headers: {
            "Authorization": sessionToken,
          },
        }
      );

      if (response.ok) {
        setSnackbarMsg("Subscriber deleted successfully!");
        setOpenSnackbar(true);
        fetchUsers(); // Refresh the user list
      } else {
        setSnackbarMsg("Failed to delete subscriber.");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Error deleting subscriber:", error);
      setSnackbarMsg("An error occurred while deleting the subscriber.");
      setOpenSnackbar(true);
    } finally {
      setDeleteBox(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteBox(false);
  };

  // Filter rows based on search term
  const filteredRows = rows.filter(row =>
    row.userName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <h2 style={{ color: "white", margin: 0 }}>Career Form Entries</h2>
                <TextField
                  variant="outlined"
                  placeholder="Search by name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ backgroundColor: "white", borderRadius: "4px" }}
                />
              </MDBox>
              <MDBox pt={3}>
                {loading ? (
                  <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="300px"
                  >
                    <CircularProgress color="info" />
                  </MDBox>
                ) : (
                  <DataTable
                    table={{ columns, rows: filteredRows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Edit User Modal */}

      <Dialog open={deleteBox} onClose={handleDeleteCancel}>
        <DialogTitle>Delete Subscriber</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this subscriber?
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for Notifications */}
      <Snackbar
        open={openSnackbar}
        message={SnackbarMsg}
        autoHideDuration={2000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setOpenSnackbar(false)}
      />
    </DashboardLayout>
  );
}

// Prop-Type Validation for the `row` object
CarrieirPage.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      userId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default CarrieirPage;